type FeatureItem = {
  name: string;
  description?: string;
  group?: string;
};

type FeatureSection = {
  key: string;
  label: string | null;
  items: FeatureItem[];
};

/**
 * Splits an upgrade-feature list into contiguous sections by `group`. Items
 * without a group form an unlabeled section; consecutive items sharing the
 * same group form a labeled section. Order is preserved.
 */
export const groupFeatures = (features: FeatureItem[]): FeatureSection[] => {
  const sections: FeatureSection[] = [];
  for (const feature of features) {
    const last = sections[sections.length - 1];
    const group = feature.group ?? null;
    if (last && (last.label ?? null) === group) {
      last.items.push(feature);
      continue;
    }
    sections.push({
      key: `${group ?? '__ungrouped__'}-${sections.length}`,
      label: group,
      items: [feature],
    });
  }
  return sections;
};
